import { Settings } from "@mui/icons-material";
import { Box, Container } from "@mui/material";
import GlobalNavigation from "../../components/GlobalNavigation";
import Header from "../../components/Header";
import Helmet from "../../components/Helmet";
import Layout, {
  LayoutStateProvider,
  SidebarSwitch,
  SideSheetTrigger,
} from "../../components/Layout";
import Loading from "../../components/Loading";
import NoDataStoreAlert from "../../components/NoDataStoreAlert";
import SettingsDrawer from "../../components/SettingsDrawer";
import { useExtraction } from "../../domain/crud";
import { useExtractionParams } from "../../paths";
import { selectData } from "../../utils";
import ExtractionForm from "./components/EditForm";

export default function EditExtraction() {
  const { extractionId } = useExtractionParams();
  const extractionQuery = useExtraction(extractionId, { select: selectData });
  const extraction = extractionQuery.data;
  return (
    <>
      <Helmet>
        <title>Edit Extraction</title>
      </Helmet>
      <LayoutStateProvider>
        <Layout
          header={
            <Header
              title="Edit Extraction"
              actions={
                <SideSheetTrigger
                  title="Settings"
                  sidebarId="settings"
                  icon={<Settings />}
                />
              }
            />
          }
          globalNavigation={<GlobalNavigation />}
          sideSheet={
            <SidebarSwitch
              config={[
                {
                  id: "settings",
                  element: <SettingsDrawer />,
                },
              ]}
            />
          }
        >
          <Box sx={{ flexGrow: 1, minWidth: 0, overflowY: "auto", py: 4 }}>
            <Container fixed>
              <NoDataStoreAlert sx={{ mb: 4 }} />
              {extraction ? (
                <ExtractionForm extraction={extraction} />
              ) : (
                <Loading type="circular" />
              )}
            </Container>
          </Box>
        </Layout>
      </LayoutStateProvider>
    </>
  );
}
